// extracted by mini-css-extract-plugin
export default {"State":"_State--Vs4gr","Signed":"_Signed--ThOuE","Declined":"_Declined--KAawi","Overdue":"_Overdue--EuOXs","Pending":"_Pending--TQChC","Draft":"_Draft--uesWg"};